import { VALIDATOR_FIELD_RULES_ADDITIONAL_INCOME } from "app/core/form-validator/validator-field-rules/validator-field-rules-additional-income";
import { VALIDATOR_FIELD_RULES_PERSONAL_INFO_CHILD } from "app/core/form-validator/validator-field-rules/validator-field-rules-personal-info-child";
import { VALIDATOR_FIELD_RULES_SEND_MESSAGE_DIALOG } from "./validator-field-rules-send-message-dialog";

export const VALIDATOR_FIELD_RULES_ALL = [
  ...VALIDATOR_FIELD_RULES_ADDITIONAL_INCOME,
  ...VALIDATOR_FIELD_RULES_PERSONAL_INFO_CHILD,
  ...VALIDATOR_FIELD_RULES_SEND_MESSAGE_DIALOG
];
